<template>
  <div>
    <div id="monitoramento">
      <div class="row">
        <div class="col-md-12 text-center">
          <vuestic-widget>
            <div class="row cabecalho">
              <div class="col-12">
                <ul class="nav nav-fill">
                  <li class="nav-item">
                    <strong> Sala </strong>
                    <br />
                    <span>{{ sala.aula.sala.sala }}</span>
                  </li>
                  <li class="nav-item">
                    <strong> Quantidade de Alunos </strong>
                    <br />
                    <span>{{ sala.aula.fotos.length }}</span>
                  </li>
                  <li class="nav-item">
                    <strong> Horario </strong>
                    <br />
                    <span> {{ horario(sala.aula.inicio,sala.aula.fim)  }} </span>
                  </li>
                  <li class="nav-item">
                    <strong> Materia </strong>
                    <br />
                    <span>{{ sala.aula.materia.titulo }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row text-center">
              <div
                class="col-sm-3"
                v-for="(foto, index) in sala.aula.fotos"
                :key="foto.id_foto_teorica + foto.foto"
              >
                <div
                  class="card"
                  @click="openModal(sala.aula.fotos.length - 1 - index)"
                >
                  <img
                    v-if="
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index]
                        .id_status === 1
                    "
                    :id="
                      foto.id_foto_teorica +
                      '_' +
                      foto.id_aula_teorica +
                      '_' +
                      index
                    "
                    class="img-thumb"
                    :src="
                      'data:image/' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].ext +
                      ';base64, ' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].foto
                    "
                    alt="foto"
                    style="border: solid 5px rgb(255, 0, 0)"
                  />

                  <img
                    v-else-if="
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index]
                        .id_status === 2
                    "
                    :id="
                      foto.id_foto_teorica +
                      '_' +
                      foto.id_aula_teorica +
                      '_' +
                      index
                    "
                    class="img-thumb"
                    :src="
                      'data:image/' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].ext +
                      ';base64, ' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].foto
                    "
                    alt="foto"
                    style="border: solid 5px rgb(255, 0, 0)"
                  />
                  <img
                    v-else-if="
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index]
                        .id_status === 3
                    "
                    :id="
                      foto.id_foto_teorica +
                      '_' +
                      foto.id_aula_teorica +
                      '_' +
                      index
                    "
                    class="img-thumb"
                    :src="
                      'data:image/' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].ext +
                      ';base64, ' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].foto
                    "
                    alt="foto"
                    style="border: solid 5px rgb(255, 251, 0)"
                  />
                  <img
                    v-else-if="
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index]
                        .id_status === 4
                    "
                    :id="
                      foto.id_foto_teorica +
                      '_' +
                      foto.id_aula_teorica +
                      '_' +
                      index
                    "
                    class="img-thumb"
                    :src="
                      'data:image/' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].ext +
                      ';base64, ' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].foto
                    "
                    alt="foto"
                    style="border: solid 5px rgb(9, 255, 0)"
                  />
                  <img
                    v-else
                    :id="
                      foto.id_foto_teorica +
                      '_' +
                      foto.id_aula_teorica +
                      '_' +
                      index
                    "
                    class="img-thumb"
                    :src="
                      'data:image/' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].ext +
                      ';base64, ' +
                      sala.aula.fotos[sala.aula.fotos.length - 1 - index].foto
                    "
                    alt="foto"
                  />
                  &nbsp;
                  <div class="row">
                    <div class="col-sm-12 text-center">
                      <h5>{{ sala.aula.fotos.length - index }} ° Foto</h5>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <vuestic-modal
                id="modal-user"
                ref="smallModal"
                :cancelClass="'none'"
                :okClass="'none'"
                :large="true"
                :closeIconShown="false"
              >
                <div v-if="salaModalCheck" class="row">
                  <div class="col-md-12">
                    <div
                      v-if="salaModalCheck"
                      class="row"
                      style="justify-content: center"
                    >
                      <div class="card">
                        <img
                          v-if="sala.aula.fotos[idFoto].id_status === 1"
                          :id="
                            sala.aula.fotos[idFoto].foto.id_foto_teorica +
                            '_' +
                            sala.aula.fotos[idFoto].foto.id_aula_teorica +
                            '_' +
                            index +
                            '_modal'
                          "
                          class="img-monit-modal"
                          :src="
                            'data:image/' +
                            sala.aula.fotos[idFoto].foto.ext +
                            ';base64, ' +
                            sala.aula.fotos[idFoto].foto
                          "
                          alt="foto"
                          style="border: solid 5px rgb(255, 0, 0)"
                        />
                        <img
                          v-else-if="sala.aula.fotos[idFoto].id_status === 2"
                          :id="
                            sala.aula.fotos[idFoto].foto.id_foto_teorica +
                            '_' +
                            sala.aula.fotos[idFoto].foto.id_aula_teorica +
                            '_' +
                            index +
                            '_modal'
                          "
                          class="img-monit-modal"
                          :src="
                            'data:image/' +
                            sala.aula.fotos[idFoto].foto.ext +
                            ';base64, ' +
                            sala.aula.fotos[idFoto].foto
                          "
                          alt="foto"
                          style="border: solid 5px rgb(255, 0, 0)"
                        />
                        <img
                          v-else-if="sala.aula.fotos[idFoto].id_status === 3"
                          :id="
                            sala.aula.fotos[idFoto].foto.id_foto_teorica +
                            '_' +
                            sala.aula.fotos[idFoto].foto.id_aula_teorica +
                            '_' +
                            index +
                            '_modal'
                          "
                          class="img-monit-modal"
                          :src="
                            'data:image/' +
                            sala.aula.fotos[idFoto].foto.ext +
                            ';base64, ' +
                            sala.aula.fotos[idFoto].foto
                          "
                          alt="foto"
                          style="border: solid 5px rgb(255, 251, 0)"
                        />
                        <img
                          v-else-if="sala.aula.fotos[idFoto].id_status === 4"
                          :id="
                            sala.aula.fotos[idFoto].foto.id_foto_teorica +
                            '_' +
                            sala.aula.fotos[idFoto].foto.id_aula_teorica +
                            '_' +
                            index +
                            '_modal'
                          "
                          class="img-monit-modal"
                          :src="
                            'data:image/' +
                            sala.aula.fotos[idFoto].foto.ext +
                            ';base64, ' +
                            sala.aula.fotos[idFoto].foto
                          "
                          alt="foto"
                          style="border: solid 5px rgb(9, 255, 0)"
                        />
                        <img
                          v-else
                          :id="
                            sala.aula.fotos[idFoto].foto.id_foto_teorica +
                            '_' +
                            sala.aula.fotos[idFoto].foto.id_aula_teorica +
                            '_' +
                            index +
                            '_modal'
                          "
                          class="img-monit-modal"
                          :src="
                            'data:image/' +
                            sala.aula.fotos[idFoto].foto.ext +
                            ';base64, ' +
                            sala.aula.fotos[idFoto].foto
                          "
                          alt="foto"
                        />
                        <br />
                        <div class="row">
                          <div class="col-md-12">
                            <button
                              title="Nenhum aluno detectado"
                              class="btn btn-danger btn-with-icon rounded-icon size"
                              @click="imageStatus(idFoto, 2)"
                            >
                              <span
                                aria-hidden="true"
                                class="fa fa-user-times"
                                style="font-size: 16px; padding-left: 6px"
                              ></span>
                            </button>
                            &nbsp;
                            <button
                              title="Sem imagem"
                              class="btn btn-danger btn-with-icon rounded-icon size"
                              @click="imageStatus(idFoto, 1)"
                            >
                              <span
                                aria-hidden="true"
                                class="fa fa-low-vision"
                                style="font-size: 16px; padding-left: 2px"
                              ></span>
                            </button>
                            &nbsp;
                            <button
                              title="Imagem com erro"
                              class="btn btn-warning btn-with-icon rounded-icon size"
                              @click="imageStatus(idFoto, 3)"
                            >
                              <span
                                aria-hidden="true"
                                class="fa fa-exclamation-triangle"
                                style="font-size: 16px; padding-left: 3px"
                              ></span>
                            </button>
                            &nbsp;
                            <button
                              title="Imagem OK"
                              class="btn btn-success btn-with-icon rounded-icon size"
                              @click="imageStatus(idFoto, 4)"
                            >
                              <span
                                aria-hidden="true"
                                class="fa fa-check"
                                style="font-size: 16px; padding-left: 3px"
                              ></span>
                            </button>
                          </div>
                        </div>
                        <br />
                        <div class="container" v-if="sala">
                          <h2>
                            <b>{{ sala.sala }}</b>
                          </h2>
                          <div class="row" style="justify-content: center">
                            <table class="table-responsive-sm">
                              <tr>
                                <td>CFC:</td>
                                <td v-if="sala.cfc">{{ sala.cfc }}</td>
                              </tr>
                              <tr>
                                <td>Turma:</td>
                                <td>{{ sala.aula.turma.titulo }}</td>
                              </tr>
                              <tr>
                                <td>Aula:</td>
                                <td>{{ sala.aula.id_aula_teorica }}</td>
                              </tr>
                              <tr>
                                <td>Instrutor:</td>
                                <td>{{ sala.aula.instrutor.nome }}</td>
                              </tr>
                              <tr>
                                <td>Materia:</td>
                                <td>{{ sala.aula.materia.titulo }}</td>
                              </tr>
                              <tr>
                                <td>Aula iniciada as:</td>
                                <td>{{ sala.aula.inicio.split(" ")[1] }}</td>
                              </tr>
                              <tr>
                                <td>Fim previsto:</td>
                                <td>{{ sala.aula.fim.split(" ")[1] }}</td>
                              </tr>
                              <tr>
                                <td>Quantidade de alunos na turma:</td>
                                <td>{{ sala.aula.turma.quantidade_alunos }}</td>
                              </tr>
                              <tr>
                                <td>Presenças confirmadas:</td>
                                <td>
                                  {{ sala.aula.quantidade_alunos_presentes }}
                                </td>
                              </tr>
                              <tr>
                                <td>Pessoas detectadas:</td>
                                <td>
                                  {{
                                    sala.aula.fotos[sala.aula.fotos.length - 1]
                                      .faces.length
                                  }}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </vuestic-modal>
            </div>
          </vuestic-widget>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MonitoramentoController from "./MonitoramentoController";
// import urlApi from '../../router/urlApi'

export default {
  data() {
    return {
      sala: this.$route.params["idSala"],
      aula: [],
      salaModalCheck: false,
      imageCheck: false,
      idFoto: 0,
    };
  },
  mounted() {
    this.atualizar();
  },
  methods: {
    atualizar() {
      let self = this;
      MonitoramentoController.getAula(function (aula) {
        if (aula != null) {
          self.sala.aula = aula;
        }
      });

      setTimeout(function () {
        self.atualizar();
      }, 60000);
    },
    openModal(idFoto) {
      let self = this;
      self.salaModalCheck = true;
      self.idFoto = idFoto;
      console.log(self.idFoto);
      self.$refs.smallModal.open();
    },
    imageStatus(key, type) {
      // let self = this
      let idFoto = this.sala.aula.fotos[key].id_foto_teorica;
      MonitoramentoController.updateFoto(idFoto, type);

      this.sala.aula.fotos[key].id_status = type;
    },
    horario(inicio, fim) {
        var ini = inicio.split(' ')[1];
        var end = fim.split(' ')[1];

        return `De ${ini} ate ${end}`;
    },
  },
};
</script>

<style scoped>
/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgb(24, 255, 3);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px; /* 5px rounded corners */
  margin: 5px;
}

/* Add rounded corners to the top left and the top right corner of the image */
.img-monit {
  width: 450px;
  border-radius: 10px 10px 0 0;
}

.img-monit-modal {
  width: 500px;
  height: 500px;
  border-radius: 10px;
}

.img-thumb {
  width: 270px;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.13);
  padding: 0;
  margin-left: 2px;
}

#clock {
  font-family: "Share Tech Mono", monospace;
  color: #080808;
  text-align: center;
}

.size {
  width: 4rem;
  height: 4rem;
}

tr {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

table {
  width: 100%;
}

.dados {
  background-color: #ffffff;
}

.cabecalho{
    border-bottom: 2px solid #eeeeee;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: rgb(238, 238, 238);

    height: 55px;
    padding: 0 1.5625rem;
    border-bottom: 2px solid #eeeeee;
    font-size: 10pt;
    font-weight: 600;
}
</style>
